import { type CSSObject } from '@emotion/react'
import { FontWeight, Spacing } from '@opallabs/gem'

const classNamePrefix = 'lapidary-calendar-month--'
export const selectors = {
  container: `${classNamePrefix}container`,
  dropdown: `${classNamePrefix}dropdown`,
  nextPrevious: `${classNamePrefix}nextPrevious`,
  pickers: `${classNamePrefix}pickers`,
  pickerTrigger: `${classNamePrefix}pickerTrigger`,
} as const

export const container = {
  inlineSize: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBlockEnd: Spacing.S,

  [`.${selectors.pickers}`]: {
    display: 'flex',
    columnGap: Spacing.S,
    marginInlineEnd: Spacing.S,
  },
  [`.${selectors.pickerTrigger}`]: {
    fontWeight: FontWeight.Bold,
  },
  [`.${selectors.dropdown}`]: {
    maxBlockSize: Spacing.XS * 45,
    minInlineSize: Spacing.XS * 30,
  },
  [`.${selectors.nextPrevious}`]: {
    columnGap: Spacing.XS,
    display: 'flex',
  },
} as const satisfies CSSObject
